import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { FooterComponent } from '../footer/footer.component';
import { TranslationSyncService } from '../../services/translation-sync.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScrollStateService } from '../../services/scroll-state.service';
import { TabDefinition } from '../../shared/models/tab.model';
import { ResumeTabKey, ResumeContent } from '../../shared/models/resume.model';
import { ResumeShellComponent } from './resume-shell/resume-shell.component';


type ResumeTranslationContent = {
  EXPERIENCE: ResumeContent['experience'];
  SKILLS: ResumeContent['skills'];
  EDUCATION: ResumeContent['education'];
};

@Component({
  selector: 'app-resume',
  imports: [CommonModule, FooterComponent, TranslateModule, ResumeShellComponent],
  templateUrl: './resume.component.html',
  styleUrl: './resume.component.css',
  encapsulation: ViewEncapsulation.None // wird benoetigt fuer dark container
})

export class ResumeComponent implements OnInit, AfterViewInit {
  @ViewChild('containerResume', { static: false }) containerRef!: ElementRef<HTMLElement>;
  @Output() toggleImprint = new EventEmitter<void>();
  @Output() togglePrivacy = new EventEmitter<void>();

  tabs: TabDefinition<ResumeTabKey>[] = [
    {
      key: 'experience',
      label: 'RESUME.TABS.EXPERIENCE',
      icon: 'bx bxl-trip-advisor',
      scrollKey: 'resume-experience'
    },
    {
      key: 'skills',
      label: 'RESUME.TABS.SKILLS',
      icon: 'bx bx-shield-quarter',
      scrollKey: 'resume-skills'
    },
    {
      key: 'education',
      label: 'RESUME.TABS.EDUCATION',
      icon: 'bx bxs-school',
      scrollKey: 'resume-education'
    }
  ];

  tabContent: ResumeContent = {
    experience: [],
    skills: [],
    education: []
  };

  activeIndex: number = 0;
  lastIndex: number = 0;
  private darkContainer!: HTMLElement;

  isDarkMode: boolean = false;

  constructor(
    private renderer: Renderer2
    , private themeService: ThemeService
    , private sync: TranslationSyncService
    , private translate: TranslateService
    , public scroll: ScrollStateService ) { }

  ngOnInit(): void {
    this.themeService.isDarkMode$.subscribe(mode => {
      this.isDarkMode = mode;
      Promise.resolve().then(() => {
        const triggeredByToggle = this.themeService.wasThemeToggled();
        this.updateTheme(triggeredByToggle);
      });
    });

    this.translate.get('RESUME.CONTENT').subscribe((content: ResumeTranslationContent) => {
      this.tabContent = {
        experience: content.EXPERIENCE,
        skills: content.SKILLS,
        education: content.EDUCATION
      };

      setTimeout(() => {
        this.registerAll(this.containerRef.nativeElement);
        const dark = document.getElementById('dark-container-resume');
        if (dark) {
          this.registerAll(dark);
        }
      }, 100);
    });
  }

  ngAfterViewInit(): void {
    const container = this.containerRef.nativeElement;
    this.darkContainer = document.getElementById('dark-container-resume') as HTMLElement;

    this.registerAll(container);

    if (this.darkContainer) {
          this.registerAll(this.darkContainer);
    }
    this.renderer.removeClass(this.darkContainer, 'active');

    Promise.resolve().then(() => {
      const triggeredByToggle = this.themeService.wasThemeToggled();
      this.updateTheme(triggeredByToggle);
    });
  }

  setActive(index: number): void {
    this.activeIndex = index;
  }

  nextActive(): void {
    this.activeIndex = (this.activeIndex + 1) % this.tabs.length;
  }

  private updateTheme(triggeredByToggle: boolean): void {
    if (!this.darkContainer || !this.containerRef?.nativeElement) {
      return;
    }

    this.syncScrollPositionOnThemeChange();
    this.themeService.toggleThemeMode(this.isDarkMode, this.renderer, this.containerRef.nativeElement, this.darkContainer);
  }

  private registerAll(root: HTMLElement): void {
    const elems = Array.from(root.querySelectorAll<HTMLElement>('[data-translate]'));
    elems.forEach(el => {
      const key = el.getAttribute('data-translate')!;
      this.sync.register(el, key);
    });
  }

private syncScrollPositionOnThemeChange(): void {
  const source = this.isDarkMode
    ? document.querySelector<HTMLElement>('#container-resume .tab-grid.active')
    : document.querySelector<HTMLElement>('#dark-container-resume .tab-grid.active');

  const target = this.isDarkMode
    ? document.querySelector<HTMLElement>('#dark-container-resume .tab-grid.active')
    : document.querySelector<HTMLElement>('#container-resume .tab-grid.active');

  if (!source || !target) return;

  target.scrollTop = source.scrollTop;
}

}
